import React from 'react';
import _ from 'lodash';

import { BaseWidget } from 'modules';
import { useQuery } from './dataService';
import { Table } from 'iron-forge-react-modules';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = useQuery(props.orderId);



  const rows = React.useMemo(
    (): types.IRow[] => _.map(queryTuple.data.agreements, (agreement): types.IRow => ({
      id: agreement.id,
      columnId2Value: {
        agreementNumber: {
          type: 'string',
          label: agreement.agreementNumber || "Not fulfilled yet"
        },
        serialNumber: {
          type: 'string',
          label: agreement.serialNumber || "Not fulfilled yet"
        },
        expiresAt: {
          type: 'string',
          label: agreement.expiresAt?.toFormat('yyyy-MM-dd') ?? "Not fulfilled yet"
        }
      }
    })),
    [queryTuple]
  );

  return !_.isEmpty(queryTuple.data.agreements) ? (
    <BaseWidget.FC title="AppleCare">
      <TableComponent
        disableSorting
        rows={rows}
        columns={[
          {
            id: 'agreementNumber',
            label: "Agreement Number"
          },
          {
            id: 'serialNumber',
            label: "Serial Number"
          },
          {
            id: 'expiresAt',
            label: "Expires At"
          }
        ]} />
    </BaseWidget.FC>
  ) : null;
};
